import React from "react";

const WHATSAPP_NUMBER = "917779894479";
const DEFAULT_MSG = "Hi NakshaCart, I'd like to know more about your services.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MSG)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with NakshaCart on WhatsApp"
      data-testid="whatsapp-floating-btn"
      className="fixed right-4 z-50 bottom-24 md:bottom-6 group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 opacity-60 animate-ping" aria-hidden />
      <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-600/30 hover:scale-110 hover:shadow-xl transition-transform">
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-current" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.998 2.706.998.33 0 2.6-.575 2.6-2.062 0-.575-.945-1.106-1.46-1.234zM16 0C7.16 0 0 7.16 0 16c0 3.025.85 5.992 2.46 8.56L.105 31.554a.504.504 0 0 0 .58.642l7.46-1.949A15.93 15.93 0 0 0 16 32c8.84 0 16-7.16 16-16S24.84 0 16 0zm0 29.286a13.243 13.243 0 0 1-6.794-1.871.5.5 0 0 0-.39-.043l-4.18 1.094 1.117-4.067a.5.5 0 0 0-.068-.402A13.214 13.214 0 0 1 2.714 16C2.714 8.66 8.66 2.714 16 2.714S29.286 8.66 29.286 16 23.34 29.286 16 29.286z" />
        </svg>
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-slate-900 text-white text-xs font-medium px-2.5 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}
